export default __webpack_public_path__ + "static/media/STORYREEL (Disable).70fcde05.png";